import { createAsyncThunk } from '@reduxjs/toolkit';
import { 
  getPlansService, 
  comparePlansService, 
  selectPlanService, 
  mergeGuestService, 
  getActiveSubscriptionService, 
  getAppConfigService, 
  syncPaymentService, 
  downloadInvoiceService 
} from './plansService';

export const getPlans = createAsyncThunk(
  'plans/getList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getPlansService();
      if (response.status) {
        return response.data;
      }
      return rejectWithValue(response.message || 'Failed to fetch plans');
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

export const downloadInvoice = createAsyncThunk(
  'plans/downloadInvoice',
  async (subscriptionId, { rejectWithValue }) => {
    try {
      const blob = await downloadInvoiceService(subscriptionId);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Invoice_${subscriptionId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      return subscriptionId;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to download invoice');
    }
  }
);

export const comparePlans = createAsyncThunk(
  'plans/compare',
  async (planIds, { rejectWithValue }) => {
    try {
      const response = await comparePlansService(planIds);
      if (response.status) {
        return response.data;
      }
      return rejectWithValue(response.message || 'Failed to compare plans');
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

export const selectPlan = createAsyncThunk(
  'plans/select',
  async (planData, { rejectWithValue }) => {
    try {
      const response = await selectPlanService(planData);
      if (response.status) return response.data;
      return rejectWithValue(response.message || 'Failed to select plan');
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

export const mergeGuestPlans = createAsyncThunk(
  'plans/merge',
  async (_, { rejectWithValue }) => {
    try {
      const response = await mergeGuestService();
      if (response.status) return response.data;
      return rejectWithValue(response.message || 'Failed to merge plans');
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

export const getActiveSubscription = createAsyncThunk(
  'plans/activeSubscription',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getActiveSubscriptionService();
      if (response.status) return response.data;
      return rejectWithValue(response.message || 'No active subscription found');
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

export const getAppConfig = createAsyncThunk(
  'plans/getAppConfig',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAppConfigService();
      if (response.status) return response.data;
      return rejectWithValue(response.message || 'Failed to fetch app configuration');
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

export const syncPayment = createAsyncThunk(
  'plans/syncPayment',
  async (paymentData, { rejectWithValue }) => {
    try {
      const response = await syncPaymentService(paymentData);
      if (response.status) return response.data;
      return rejectWithValue(response.message || 'Failed to sync payment');
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);
